import { ReactSelectStyles } from '../../utils/types'
import customTheme from '../../../../../../tailwind.config.js'
import { useCallback } from 'react'
import { styleRules } from '@components/v2/SimulationBanner/components/select/styles-rules'

interface Props<T> extends ReactSelectStyles<T> {
  width: number
  isError?: boolean
}

export const stylesSelect = <T>({ width, isError }: Props<T>) => {
  const customStyles = useCallback(() => styleRules(width), [width])
  const { controlStyle, placeholderStyle } = customStyles()

  const styles = {
    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      fontSize: '0.875rem',
      background: isSelected ? '#828282' : isFocused ? '#dedede' : undefined,
      fontFamily: customTheme.theme.fontFamily.myriad.toString(),
      color: isSelected ? '#FFF' : '#000',
      ':hover': {
        ...provided[':hover'],
        background: '#dedede',
        cursor: 'pointer'
      }
    }),
    dropdownIndicator: provided => ({
      ...provided,
      padding: '4px'
    }),
    valueContainer: provided => ({
      ...provided,
      padding: '0px 16px'
    }),
    singleValue: provided => ({
      ...provided,
      fontWeight: 'normal',
      color: customTheme.theme.colors.black
    }),
    control: (provided, { isFocused, isDisabled }) => ({
      ...provided,
      color: customTheme.theme.extend.colors.red,
      boxShadow: isFocused
        ? `0 0 0 0.15rem ${isError ? 'rgb(220 53 69 / 25%)' : '#c9c9c9'}`
        : undefined,
      borderColor: isError
        ? customTheme.theme.colors.v3.red[400]
        : customTheme.theme.colors.v3.gray[250],
      borderRadius: 9999,
      fontFamily: customTheme.theme.fontFamily.myriad.toString(),
      paddingTop: '1px',
      backgroundColor: isDisabled ? '#E3E3E3' : '#fff',
      ...controlStyle,
      minHeight: '32px',
      lineHeight: '1',
      ':hover': {
        borderColor: isError
          ? customTheme.theme.extend.colors.red
          : customTheme.theme.colors['v2-sonic-silver']
      }
    }),
    placeholder: provided => ({
      ...provided,
      ...placeholderStyle,
      color: isError
        ? customTheme.theme.colors.v3.red[400]
        : customTheme.theme.colors['v2-sonic-silver'],
      textTransform: 'uppercase'
    })
  }
  return {
    ...styles
  }
}
